import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider";
import routes from "../routes";

const PrivatePage = () => {
	const user = useAuth();
	if (!user.token) return <Navigate to={routes.login} />;
	return <Outlet />;
};

export default PrivatePage;
